module.exports = __webpack_public_path__ + "static/media/rawkstars-image.d875add8.png";